<template>
  <div class="">
    <v-select
      v-model="recipients"
      :options="recipientOptions"
      :clearable="false"
      taggable
      multiple
      :create-option="(text) => ({ label: text, value: text })"
      @input="onChange"
      :disabled="isSelectDisabled"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import vSelect from "vue-select";

export default {
  components: {
    BSpinner,
    vSelect
  },
  props: {
    fieldOptions: Object,
    context: Object
  },
  setup(props, { emit }) {
    const recipients = ref(false);
    const recipientOptions = ref([]);
    const isSelectDisabled = ref(false);

    onMounted(() => {
      isSelectDisabled.value = props.context.attributes.disabled ?? false;
      recipients.value = props.context.model
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          recipients.value = newValue
        }
      },
      { immediate: true }
    );

    async function onChange(value) {
      props.context.model = value
    }

    return {
      recipients,
      recipientOptions,
      isSelectDisabled,
      onChange
    }
  }
}
</script>